/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IPisos from 'Infotrack@Modelos/smartStock/pisos/entidades/pisos';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { useSelector } from 'react-redux';
import PisosCM from '../controladorModelo/pisosCM';
import { acciones, IEstadoPisos } from '../reductorPisos';
import PisosVista from '../vista/tablaPisosVista';

const pisosCM = new PisosCM();

const TablePisosCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [pisoss, setPisoss] = React.useState<IPisos[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoPisos>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarPisos();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarPisos = () => {
        manejadorIndicadorCargaGlobal(true);
        pisosCM.consultarPisosPorFiltro({EmpresaId:idEmpresa}).then((pisoss) => {
            setPisoss(modificarPropiedadesPisos(pisoss));
            manejadorIndicadorCargaGlobal(false);
        });
    };

    const modificarPropiedadesPisos = (pisos: IPisos[]) => {
        return pisos.map((piso) => ({
            ...piso,
            Estado: piso.Estado !== 1 ? 0 : piso.Estado,
        }));
    };

    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadPisos?: IPisos) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadPisos, tipoFormulario } });
    };

    const confirmarEliminacion = (pisos: IPisos) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarPisos(pisos),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarPisos = (pisos: IPisos) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        pisosCM.eliminarPisos(pisos).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <PisosVista
            pisoss={pisoss}
            cargarPisos={cargarPisos}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TablePisosCV;
